<mat-form-field class="example-full-width" [ngStyle]="{ 'width.px': width }" [appearance]="appearance">
  <mat-label>{{ placeholder }}</mat-label>
  <input id="inputFilterText" type="text" matInput [formControl]="searchControl" [matAutocomplete]="auto" [placeholder]="placeholder" value="{{ value }}" />
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="getDisplayFn()">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option" (click)="selected(option)">{{ option.getDisplayValue() }} </mat-option>
  </mat-autocomplete>
</mat-form-field>
